export const OPERATION_STATUS_PENDING = 'pending';
export const OPERATION_STATUS_FAILED = 'failed';
export const OPERATION_STATUS_SUCCEED = 'succeed';

export const OPERATION_TYPE_CREATE = 'create';
export const OPERATION_TYPE_UPDATE = 'update';